import React, { memo } from "react";
import { styled } from "styled-components";
import { Expand } from "lucide-react";
import RecipeStepImages from "./RecipeStepImages";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  margin-bottom: 16px;
  align-items: stretch;
  width: 100%;
  flex: 1;
  color: ${({ theme }) => theme.colorOnSurface};

  &:hover > * > button[data-expand] {
    opacity: 1;
  }
`;
const Title = styled.h4`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
  margin-top: 0px;
  padding: 0px 12px;
  flex: 1;
`;
const ExpandButton = styled.button`
  margin-left: auto;
  background: none;
  border: none;
  padding: 2px;
  cursor: pointer;
  color: ${({ theme }) => theme.colorOnSurface};
  display: flex;
  align-items: center;
  opacity: 0;
  transition: opacity 0.15s;
`;
const Desc = styled.p`
  margin-bottom: 8px;
  margin-top: 0px;
  padding: 0px 12px;
  flex: 1;
`;
const TimeStamp = styled.button`
  background-color: ${({ theme }) => theme.colorSecondary};
  color: ${({ theme }) => theme.colorOnSecondary};
  border: none;
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  cursor: pointer;
`;
const parseTimeToSeconds = (time) => {
  if (typeof time === "number") return time;
  const parts = String(time).split(":").map(Number);
  if (parts.length === 1) return parts[0];
  if (parts.length === 2) return parts[0] * 60 + parts[1];
  return parts[0] * 3600 + parts[1] * 60 + parts[2];
};

const RecipeStep = memo(function ({ title, desc, images, time, onSeek, onExpand }) {
  return (
    <Container>
      <Title>
        <TimeStamp onClick={() => onSeek?.(parseTimeToSeconds(time))}>{time}</TimeStamp>
        {title}
        <ExpandButton data-expand onClick={onExpand}>
          <Expand size={14} />
        </ExpandButton>
      </Title>
      <Desc>{desc}</Desc>
      {images?.length > 0 && (
        <RecipeStepImages
          images={images}
          onImageClick={(imgIndex) => onExpand?.(imgIndex)}
        />
      )}
    </Container>
  );
});
export default RecipeStep;
